<template>
  <v-dialog
    v-model="dialog"
    max-width="648px"
    v-bind="$attrs"
  >
    <v-card>
      <v-card-title class="px-6 pt-6">
        <v-row class="flex-row-reverse pa-0">
            <v-icon color="boldText" @click="closeModal">ph ph-x</v-icon>
        </v-row>
      </v-card-title>
      <div class="py-16 px-8">
        <v-row justify="center" class="ma-0 pa-0">
          <v-col cols="12" class="text-center ma-0 pa-0">
            <img
              :src="$theme.baseAmbienteUrl + info.img + '.svg'"
              alt="Error SVG"
              class="info-image"
              width="150"
              height="150"
            />
          </v-col>
        </v-row>

        <v-card-text class="text-center pa-0 ma-0">
          <slot name="title">
            <div class="info-title">{{ info.title }}</div>
          </slot>
          <slot name="subtitle">
            <div class="info-subtitle">{{ info.subtitle }}</div>
          </slot>
          <slot name="footer"></slot>
        </v-card-text>
      </div>
      <div class="px-4">
        <v-divider />
      </div>
      <v-card-actions>
        <slot name="actions">
          <v-btn  x-large @click="back" class="rounded-btn" :max-height="40" v-if="backAction">Voltar</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="#1A1889"
            @click="next"
            class="white--text"
            x-large
            :max-height="40"
          >
            {{ textAction }}
          </v-btn>
        </slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data () {
    return {
      dialog: false,
      ambiente: localStorage.ambiente
    }
  },
  props: {
    info: {
      type: Object,
      required: true,
    },
    textAction: {
      type: String,
      default: 'Continuar'
    },
    backAction: null,
    nextAction: null,
  },
  methods: {
    openModal () {
      this.dialog = true
    },
    closeModal () {
      this.dialog = false
      this.$emit('response')
    },
    back () {
      if (this.backAction) this.backAction()
    },
    next () {
      if (this.nextAction) {
        this.nextAction()
      } else this.closeModal()
    }
  },
}
</script>

<style scoped>
.info-image {
  max-width: 100%;
}
.info-subtitle {
  margin-top: 30px;
}
.info-title {
  font-size: 2em;
  font-weight: bold;
  font-weight: 500;
  line-height: 1.3;
}
.rounded-btn {
  border-radius: 5px;
}
</style>
